import React, { useMemo, useContext, ReactElement } from "react";
import { FieldProps } from "./Field/types";
import { AuthContext } from "context";
import ListItemColumn from "./ListItemColumn";

interface Props<TRecord> {
    currentSort?: { field?: string; order: "asc" | "desc" };
    data: Array<TRecord>;
    selectedIds?: Array<unknown>;
    isSelected?: (record: TRecord) => boolean;
    onToggleItem?: (record: TRecord) => void;
    hasBulkActions?: boolean;
    onSelect?: (records: Array<TRecord>) => void;
    isRowSelectable?: (record: TRecord) => boolean;
    setSort?: (field: string) => void;
    onRowClick?: (record: TRecord, e?: React.MouseEvent) => void;
    children: Array<ReactElement<FieldProps>>;
    rendererHeader: (record: TRecord) => React.ReactNode | string | null;
    grid?: number;
    classContainerItem?: string;
}

const ListItem = <TRecord,>({
    data,
    onRowClick,
    children,
    rendererHeader,
    grid,
    classContainerItem,
}: Props<TRecord>) => {
    const { isAllowed } = useContext(AuthContext);

    const filteredChildren = useMemo(() => {
        return children.filter((field) => {
            const authorized = field.props.capability ? isAllowed(field.props.capability) : true;

            return authorized;
        });
    }, [children, isAllowed]);

    return (
        <React.Fragment>
            {data.map((record, rowDataIndex) => (
                <div
                    className={`search_result-item ${classContainerItem ? classContainerItem : ""} ${
                        grid ? "grid-" + grid : ""
                    }`}
                    key={rowDataIndex}
                    onClick={() => onRowClick && onRowClick(record)}
                >
                    <div className="search_result-item_checkbox"></div>
                    <div className="search_result-item_content h-full">
                        <div className="item_container h-full">
                            {rendererHeader(record)}
                            <div className="item_content">
                                {filteredChildren.map((field, index) => (
                                    <ListItemColumn
                                        record={record}
                                        field={field}
                                        className={field.props.className}
                                        key={field.props.source || index}
                                    />
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            ))}
        </React.Fragment>
    );
};

export default ListItem;
